import React from "react";
import { Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { HubButton } from "../../components";

const ManageMoldButtons = ({
  disabled = false,
  isLoading = false,
  label = "Submit",
  fullWidth = false,
  onClose = () => {},
  disableOnInvalid = false,
  ...rest
}) => {
  const { formState } = useFormContext();

  return (
    <Stack direction="row" justifyContent="center" gap="10px" {...rest}>
      <HubButton
        variant="contained"
        color="grey"
        label="Cancel"
        size="small"
        onClick={onClose}
        sx={{ flexGrow: 1, padding: "5px" }}
        disabled={disabled}
      />
      <HubButton
        id="ModalDisplaySubmit"
        variant="contained"
        type="submit"
        size="small"
        label="Add Mold"
        sx={{ flexGrow: 1, padding: "5px" }}
        disabled={disabled || (disableOnInvalid && !formState.isValid)}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default ManageMoldButtons;
